import React from 'react';

export default function BenefitJobCard({title, descriptions, image}) {
    return (
        <div className="benefit-job-card">
            <img src={image} alt={title} />
            <h3>{title}</h3>
            <p>{descriptions}</p>
        </div>
    );
}
